import { useMutation } from "@tanstack/react-query";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { settings } from "../../../../helpers/toast.settings";
import { addStorageArea } from "../../../../services/storage-area/add";
import styled from "styled-components";
import { theme } from "../../../../helpers/theme";
import { StyledButton } from "../../../../components/Button/button";
import { Input } from "../../../../components/Input/input";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useParams } from "react-router-dom";
import * as yup from "yup";
import { GoBackButton } from "../../../../components/GoBackButton";
import {
  FiscalBreakdownArray,
  StoragePlaceArray,
  StorageTypeArray,
  TemperatureConditionArray,
} from "./helpers";

const StorageAreaAdd = () => {
  const { id } = useParams();
  const AddStorageAreaMutation = useMutation(addStorageArea, {
    onSuccess: (res) => {
      toast.success("Dodano pomyślnie!", {
        toastId: "StorageAreaAddSuccessfully",
        ...settings,
      });
    },
  });
  const validationSchema = yup.object({
    kod: yup
      .string()
      .required("Kod jest wymagany")
      .max(100, "Maksymalnie 100 znaków"),
  });
  const formik = useFormik({
    initialValues: {
      kod: "",
      typ_skladowania: 0,
      miejsce: 0,
      podzial_fiskalny: 2,
      warunek_temperaturowy: 0,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const body = {
        id_magazyn: id,
        kod: formik.values.kod,
        typ_skladowania: formik.values.typ_skladowania,
        miejsce: formik.values.miejsce,
        podzial_fiskalny: formik.values.podzial_fiskalny,
        warunek_temperaturowy: formik.values.warunek_temperaturowy,
      };

      AddStorageAreaMutation.mutate(body);
    },
  });
  return (
    <>
      <ButtonWrapper>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
      </ButtonWrapper>
      <StorageAreaAddContainer>
        <FormWrapper onSubmit={formik.handleSubmit}>
          <Input
            label="Kod"
            placeholder="Wpisz kod..."
            id="kod"
            name="kod"
            value={formik.values.kod}
            onChange={formik.handleChange}
            error={formik.touched.kod && Boolean(formik.errors.kod)}
            helperText={formik.touched.kod && formik.errors.kod}
            onBlur={formik.handleBlur}
            variant="filled"
          />
          <FormControl fullWidth>
            <InputLabel id="typ_skladowania-label">Typ składowania</InputLabel>
            <Select
              placeholder="typ_skladowania"
              labelId="typ_skladowania-label"
              label="typ_skladowania"
              id="typ_skladowania"
              name="typ_skladowania"
              value={formik.values.typ_skladowania}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ backgroundColor: "white" }}
            >
              {StorageTypeArray.map((item, index) => (
                <MenuItem value={index}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth>
            <InputLabel id="miejsce-label">Miejsce </InputLabel>
            <Select
              placeholder="miejsce"
              labelId="miejsce-label"
              label="miejsce"
              id="miejsce"
              name="miejsce"
              value={formik.values.miejsce}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ backgroundColor: "white" }}
            >
              {StoragePlaceArray.map((item, index) => (
                <MenuItem value={index}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="podzial_fiskalny-label">
              Podział fiskalny
            </InputLabel>
            <Select
              placeholder="podzial_fiskalny"
              labelId="podzial_fiskalny-label"
              label="podzial_fiskalny"
              id="podzial_fiskalny"
              name="podzial_fiskalny"
              value={formik.values.podzial_fiskalny}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ backgroundColor: "white" }}
            >
              {FiscalBreakdownArray.map((item, index) => (
                <MenuItem value={index}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel id="warunek_temperaturowy-label">
              Warunek temperaturowy
            </InputLabel>
            <Select
              placeholder="warunek_temperaturowy"
              labelId="warunek_temperaturowy-label"
              label="warunek_temperaturowy"
              id="warunek_temperaturowy"
              name="warunek_temperaturowy"
              value={formik.values.warunek_temperaturowy}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              style={{ backgroundColor: "white" }}
            >
              {TemperatureConditionArray.map((item, index) => (
                <MenuItem value={index}>{item}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <StyledButton
            disabled={AddStorageAreaMutation.isLoading || !formik.isValid}
            type="submit"
            variant="contained"
          >
            Zapisz
          </StyledButton>
        </FormWrapper>
      </StorageAreaAddContainer>
    </>
  );
};

export default StorageAreaAdd;

const FormWrapper = styled.form`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 420px;
  gap: 25px;

  @media (${theme.device.laptop}) {
    width: 100%;
  }
`;
const StorageAreaAddContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-left: 0;
  margin-top: 0px;
  padding-top: 20px;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
    width: 70%;
    margin-top: -50px;
  }
`;
const ButtonWrapper = styled.div`
  width: 70%;
  margin-left: 30px;
  // display: flex;
  // justify-content: flex-start;

  @media (${theme.device.laptop}) {
    margin-left: 320px;
  }
`;
